export default {
  "title": "How is Connecticut in 2018 compared to 2013?",
  "subtitle": "American Community Survey 2018 5-year estimates for Connecticut towns and census tracts compared to ACS 2013 5-year estimates by <a href='http://ctdata.org' class='link blue dim'>CTData Collaborative</a>",
  "footer": "&copy; 2019 CTData Collaborative. Data by ACS 2018 5-year estimates; 2013 5-year estimates.<br>For feedback, email <a href='mailto:info@ctdata.org' class='link blue dim'>info@ctdata.org</a>.",
  "defaultGeographyPath": "./geo/towns.geojson",
  "extraGeographyPath": "./geo/tracts.geojson",
  "extraGeographyName": "Census tracts",
  "geojsonGeographyProperty": "name",
  "data": [
    {
      "name": "Median household income",
      "file": "./data/median-hh-income.csv",
      "prefix": "$",
      "suffix": "",
      "beforemoe": true,
      "aftermoe": true,
      "positiveIncrease": true,
      "description": "In Connecticut, median household income increased by 9.6%, from $69,461 to $76,103. Of 169 towns, 147 experienced an increase in household income, while in 22 towns it decreased. The capital city of Hartford has the lowest median household income among all towns, $34,338. New London is the only other towns where household income does not exceed $40,000. Darien ($210,411) and Weston ($219,083) are the two towns where median income exceeds $200,000. Other richest towns are Wilton ($187,903), Westport (187,988) and New Canaan (192,428). Mansfield and Thomaston experienced a decline in household income of over 10%, while East Granby, Westbrook, and Roxbury experienced an increase of over 40% each."
    },
    {
      "name": "Per capita income",
      "file": "./data/pc-income.csv",
      "prefix": "$",
      "suffix": "",
      "beforemoe": true,
      "aftermoe": true,
      "positiveIncrease": true,
      "description": "In Connecticut, per capita (per person) income increased by 13.6%, from $37,892 to $43,056. Of 169 towns, nearly all (163) experienced an increase in per capita income. The capital city of Hartford has the second lowest per capita income among all towns, $20,066, nearly the same as Windham, the town with the lowest income ($20,064). New Canaan, Darien, and Westport are the three towns in Connecticut whose per capita income exceeds $100,000. Greenwich ($98,467) and Weston (99,698) follow. The only 6 towns with a decrease in per capita income are Woodbridge (-13%), Killingworth (-5.8%), Ashford (-3.3%), Windham (-1.1%), Granby (-1.1%), and Essex (-0.9). In Canaan, Roxbury, Union, and Westbrook increases in per capita income were over 40%."
    },
    {
      "name": "Median home value",
      "file": "./data/home-val.csv",
      "prefix": "$",
      "suffix": "",
      "beforemoe": true,
      "aftermoe": true,
      "positiveIncrease": true,
      "description": "In Connecticut, median home value decreased by over $6,000 (-2.2%) down to to $272,700. Waterbury is the town is the lowest home value of around $128,800, followed by Torrington ($155,700), Windham ($155,900) and New Britain ($159,300). Hartford ($162,800) and Bridgeport ($173,100) are among the cheapest towns as well. Median home values of over $1 million are in Westport ($1,167,500), Greenwich ($1,278,000), New Canaan ($1,420,000), and Darien ($1,461,100). West Hartford (+8%), Chester (+10%), Lyme (+15%), and Norfolk (+22%) experienced the biggest increases in home values."
    },
    {
      "name": "Median gross rent",
      "file": "./data/rent.csv",
      "prefix": "$",
      "suffix": "",
      "beforemoe": true,
      "aftermoe": true,
      "positiveIncrease": true,
      "description": "Median gross rent in Connecticut increased by 9.5%, from $1,056 to $1,156. The rent value increased in 117 towns and decreased in 44. Among the most expensive towns to rent a home are Darien ($2,801), Weston ($2,759), and Wilton ($2,690), among the most affordable are Franklin ($690), Lebanon ($696), Harwinton ($748), and Oxford ($798)."
    },
    {
      "name": "Population",
      "file": "./data/total-pop.csv",
      "prefix": "",
      "suffix": " people",
      "beforemoe": true,
      "aftermoe": true,
      "positiveIncrease": true,
      "description": "The population in Connecticut decreased by about 2,000 people. In most towns (116 or 169), the population experienced a decrease as well. Some of the smallest towns in the state are Union (873), Canaan (1,196), Cornwall (1,302),  and Warren (1432). The top-5 biggest towns are Bridgeport (146,417), New Haven (130,529), Stamford (129,026), Hartford (123,628), and Waterbury (108,672). Stamford experienced the biggest population growth of just over 5,000 people (a 4.1% increase) compared to 2009–2013 estimates. Some other towns that experienced a large increase in population are Danbury (~2,500), Norwalk (~1,900), Fairfield (~1,500), and Milford (~1,150). Hartford lost the most population (around 1,500)."
    },
    {
      "name": "Median age",
      "file": "./data/age.csv",
      "prefix": "",
      "suffix": " years",
      "beforemoe": true,
      "aftermoe": true,
      "positiveIncrease": true,
      "description": "The median age of Connecticut population increased by 0.6 years, from 40.2 to 40.8. At the same time, 31 towns became “younger”, with Willington, Ledyard, Colebrook, and Bethlehem experiencing a decrease in median age of over 2 years. Some of the youngest towns in the state are Mansfield (21.1), Windham (30.0), New Haven (30.6), New London (31.0), and Hartford (31.5). Some of the “oldest” towns are Bridgewater, Washington, Sharon, and Salisbury, where the median age is above 55."
    },
    {
      "name": "High school graduates or higher, %",
      "file": "./data/high-school-plus.csv",
      "prefix": "",
      "suffix": "%",
      "beforemoe": false,
      "aftermoe": false,
      "positiveIncrease": true,
      "description": "In Connecticut, the share of population aged 25 and older who hold at least a high school diploma (or equivalent) increased by 1.3 percentage points, from 89.2% to 90.5%. The share increased in 128 towns and decreased in 41. Sherman, Redding, Weston, Roxbury, Westport, Killingworth, Madison, and Tolland all have rates of above 98%. Hartford (74.2%), Bridgeport (76.5%), Waterbury (80.0%), and New Britain (81.1%) are among the towns with the lowest proportion of population with a high school diploma or higher."
    },
    {
      "name": "Population with bachelor's or higher, %",
      "file": "./data/bachelor-plus.csv",
      "prefix": "",
      "suffix": "%",
      "beforemoe": false,
      "aftermoe": false,
      "positiveIncrease": true,
      "description": "In Connecticut, the share of population aged 25 and older who holds a bachelor’s degree or above increased by 2.4 percentage points, from 36.5% to 38.9%. The share increased in 127 towns and decreased in 42. Darien (81.3%), Weston (81.2%), New Canaan (79.3%), Westport (78.0%), and Wilton (76.6%) have the highest share of population with a bachelor’s+, and are all located in Fairfield County. Waterbury (15.8%), Hartford (16.8%), and Bridgeport (18.3%) are among the towns with the lowest share of population with a bachelor's or graduate degrees."
    }
  ]
}
